import Autocomplete from 'apollo-react/components/Autocomplete';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AUTOCOMPLETE_CLOSE_TEXT, AUTOCOMPLETE_OPEN_TEXT } from '../../constants/Common';
import { TRANSLATE_DATA_COLUMN_VALUES_SEPARATOR } from '../../constants/SavedSearches';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { AUTOCOMPLETE_NO_OPTIONS_TEXT } from '../../form-designer/constants/runtime.constants';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import { getTranslatedColumnListByKeyAsOptions } from '../../selectors/TranslatedColumnListsSelectors';
import { getTranslatedColumnListKey, SavedSearchNameContext } from '../../utils/savedSearchUtils';

const AutoCompleteFilter = ({ accessor, filters, updateFilterValue }) => {
  const savedSearchName = useContext(SavedSearchNameContext);
  const key = getTranslatedColumnListKey(savedSearchName, accessor);
  const options = useSelector(getTranslatedColumnListByKeyAsOptions(key), equalityFn);
  const translateString = useTranslation();

  const autoCompleteValue = useMemo(() => {
    if (filters[accessor] && options.length) {
      const selectedValues = filters[accessor].split(TRANSLATE_DATA_COLUMN_VALUES_SEPARATOR);
      return options.filter((option) => selectedValues.includes(option.value));
    }

    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filters), options]);

  const handleChange = (_, newValue) => {
    updateFilterValue({
      target: {
        name: accessor,
        value: newValue.length
          ? newValue.map((obj) => obj.value).join(TRANSLATE_DATA_COLUMN_VALUES_SEPARATOR)
          : '',
      },
    });
  };

  return (
    <Autocomplete
      ui-ta="autocompleteFilter"
      size="small"
      chipColor="white"
      fullWidth
      multiple
      matchFrom="any"
      source={options}
      value={autoCompleteValue}
      onChange={handleChange}
      noOptionsText={translateString(AUTOCOMPLETE_NO_OPTIONS_TEXT.NO_OPTIONS)}
      openText={translateString(AUTOCOMPLETE_OPEN_TEXT)}
      closeText={translateString(AUTOCOMPLETE_CLOSE_TEXT)}
    />
  );
};

export default AutoCompleteFilter;
